<template>
  <v-checkbox
    v-model="item.is_consent"
    :true-value="1"
    :false-value="0"
    :id="item.name"
    density="compact"
    style="--v-icon-size: 12px; --v-selection-control-size: 12px"
    hide-details
    :class="
      $isCleanLayout ||
      $isShowTab ||
      ($isMinimalCompact && !$config.isMinimalSharp) ||
      $isMinimalProfileBanner
        ? 'no-check-icon'
        : ''
    "
  >
    <template v-slot:label>
      <div>
        <template v-for="(part, index) in item.parsedDescription" :key="index">
          <span
            v-if="part === '{{term}}'"
            class="text-underline"
            @click.prevent="openTerm"
          >
            {{ $t("term") }}
          </span>
          <span
            v-else-if="part === '{{policy}}'"
            class="text-underline"
            @click.prevent="openPolicy"
          >
            {{ $t("policy") }}
          </span>
          <template v-else><span v-html="part"></span></template>
        </template>
        <span
          v-if="item.is_required_in_edit_profile == 1"
          class="text-consent-danger"
          >&nbsp;*
        </span>
      </div>
    </template>
  </v-checkbox>
</template>

<script>
export default {
  name: "ConsentItem",
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  methods: {
    openPolicy() {
      this.emitter.emit("showModal", "policy");
    },
    openTerm() {
      this.emitter.emit("showModal", "term");
    }
  }
};
</script>

<style lang="scss" scoped>
.text-underline {
  text-decoration: underline;
}
</style>
